import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IWikiModel } from '@app/core/interfaces/wiki-model-interface';
import { aptitudes_model } from './aptitudes-model';
import { aboutUsMissionsAndValuesModel } from '@app/core/components/help-options/help-options-model';

@Component({
    selector: 'app-aptitudes',
    templateUrl: './aptitudes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./aptitudes.component.scss']
})
export class AptitudesComponent {
    @Input() public urlImage: string = '';
    @Input() public title: string = '';
    @Input() public content: string = '';

    public aptitudesModel: Array<IWikiModel> = aptitudes_model;
    public aboutUsMissionsAndValues: Array<any> = aboutUsMissionsAndValuesModel;
}
